import React from 'react';
import chooseadayastyles from "./chooseadayastyles.module.css"
import Cards from "../../components/cards/Cards"
import Guarantee from "../../assets/Icon/icons8-guarantee-90.png"
import Farmers from "../../assets/Icon/icons8-farmer-96.png"
import Mobile from "../../assets/Icon/icons8-mobile-order-96.png"
import Profit from "../../assets/Icon/icons8-profit-96.png"
import Chemical from "../../assets/Icon/chemical.png"
import basestyles from "../../styles/basestyles.module.css"

const ChooseAdaya = () => {

    return (
       <>
        <div id="whyus" className={chooseadayastyles.Cards}>
        <div className={basestyles.maxWidth}>
            <div className={chooseadayastyles.heading}>
                 <h1>Why Choose Adaya</h1> 
                 <h2>Your Trusted Farm Fresh Produce Destination In Karnataka!</h2>
            </div>
       <div className={chooseadayastyles.adayaCards}>          
            <Cards src={Guarantee} h2="High Quality Guaranteed" />
            <Cards src={Farmers} h2="Directly From Farmers" />
            <Cards src={Profit} h2="Economical" />
            <Cards src={Mobile} h2="Ease Of Ordering" />
            <Cards src={Chemical} h2="Chemical Free" />
      </div>
      </div>
      </div>
       </>
    );
}
 
 
export default ChooseAdaya;